webpackJsonp([24],{

/***/ "23PY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "78rx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_page_activity_scss__ = __webpack_require__("23PY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_page_activity_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_css_page_activity_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_common_index__ = __webpack_require__("4PxH");





function bindEvts() {
  memberFormInit();
}

function memberFormInit() {
  __WEBPACK_IMPORTED_MODULE_1_js_common_index__["n" /* memberShip */].closeForm.init();
  __WEBPACK_IMPORTED_MODULE_1_js_common_index__["n" /* memberShip */].forgetPwdFormInit({
    form: '.yui-memberform0-forgetpwd',
    mask: '.mask-member'
  });
  __WEBPACK_IMPORTED_MODULE_1_js_common_index__["n" /* memberShip */].loginFormInit({
    success: function success() {
      return Object(__WEBPACK_IMPORTED_MODULE_1_js_common_index__["l" /* headerInit */])();
    },
    form: '.yui-memberform0-login',
    mask: '.mask-member'
  });
  __WEBPACK_IMPORTED_MODULE_1_js_common_index__["n" /* memberShip */].registerFormInit({
    form: '.yui-memberform0-register',
    mask: '.mask-member'
  });
}

function uiInit() {}

window._dataBus.get('domReadyObserver').subscribe(function () {
  uiInit();
  bindEvts();
});

/***/ })

},["78rx"]);


// WEBPACK FOOTER //
// js/activity.js